import { Component, OnInit, Output, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SdtService } from 'src/app/services/sdt.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RestService } from 'src/app/services/rest-service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppSettings } from 'src/app/shared/app-settings';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';

export interface DialogData {
  msg: string;
}


@Component({
  selector: 'app-sdt-form',
  templateUrl: './sdt-form.component.html',
  styleUrls: ['./sdt-form.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule, MatButtonModule]
})
export class SdtFormComponent implements OnInit {
  submitted = false;
  sdtForm!: FormGroup;
  minDateFrom = new Date();

  email;
  devices;
  deviceNames = [];
  currentuser;
  username: string;
  readOnlyUser: boolean;
  sdtReason;
  startDate;
  endDate;
  reason;
  createdTime;
  updatedTime;
  createdBy;
  updatedBy;
  loading: boolean;
  postData: any;
  selectedOption = null;
  minDate = new Date();
  maxDate: Date;
  toDateMaxDate: Date;
  fromDateMinDate: Date;
  dateConvert: string;
  createdTime1: any;
  start: any;
  end: any;
  dateObj: any;
  linkedForm = false;
  createdByForm: any;
  updatedByForm: any;
  sdtDevices: any;
  dbData: any;
  formExists = false;
  reasonTag: any;
  modifiedReason: any;
  data: any;
  dataLength: any;
  formattedData: any[];
  selectedDevicesLength: number;
  devicesLength: any;
  sdtSubReason: string;

  constructor( private titleService: Title,
    private sdtService: SdtService, private router: Router, private fb: FormBuilder, public authService: AuthenticationService,
    public restService: RestService,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private datePipe: DatePipe
  ) { 
    this.titleService.setTitle("SDT-Form");

  }

  ngOnInit(): void {
    this.onDateChange
    var date = new Date();
    this.formData()
    this.formatSdt()
    this.dbData = this.sdtService.DBdata
    let title = this.titleService.getTitle();
    this.currentuser = this.authService.currentUserValue;
    const date1 = new Date(this.sdtService.formData.sdtStartDate);
    const month = date1.getMonth() + 1;
    const day = date1.getDate();
    const year = date1.getFullYear();
    if (this.currentuser) {
      this.username = this.currentuser.firstName;
      this.createdByForm = this.currentuser.email;
      this.updatedByForm = this.currentuser.email;
      this.sdtService.formData.createdBy = this.createdByForm;
      this.sdtService.formData.updatedBy = this.updatedByForm;
      if (this.currentuser['privileges'] && this.currentuser['privileges'].length > 0) {
        for (let i = 0; i < this.currentuser['privileges'].length; i++) {
          if (this.currentuser['privileges'][i].toLowerCase() === 'view sdtform') {
            this.readOnlyUser = true;
            this.getSdtForm();
          }
        }
      }
    }
    this.devices = this.sdtService.selectedDevices
    this.createdTime1 = this.sdtService.createdAt
    this.startDate = this.datePipe.transform(this.sdtService.formData.sdtStartDate, 'MM-dd-yyyy')
    // this.startDate = `${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}-${year.toString()}`;
    this.endDate = this.sdtService.formData.sdtEndDate
    if (this.devices && this.devices.length > 0 && this.devices !== undefined && this.devices !== null) {
      this.deviceNames = this.devices
        .filter(ele => ele && ele.deviceName !== undefined && ele.deviceName !== null && ele.deviceName !== '')
        .map(ele => ele.deviceName);
      }    
    this.createdBy = this.sdtService.createdBy
    this.sdtForm = this.fb.group({
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      reason: ['', Validators.required],
      otherReason: ['']
    })
    let currentDevice = this.sdtService.selectedDevice;
    this.dateObj = this.sdtService.DBdata?.filter(ele => ele.siteUnitId == currentDevice['siteUnitId'])
    if (this.dateObj) {
      this.start = this.dateObj[0]?.sdtStartDate
      this.end = this.dateObj[0]?.sdtEndDate
      if (this.start != undefined) {
        this.formExists = true;
        this.linkedForm = true;
      }
    }
  }

  sdtFormData;
  getSdtForm() {
    this.spinner.activate();
    this.loading = true;
    this.restService.getRequest(AppSettings.SDTPOST, '').subscribe((response) => {
      this.sdtFormData = response
      this.spinner.deactivate();
      this.loading = false;
    }, (err) => {
      this.spinner.deactivate();
      this.loading = false;
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Session Expired Please login again.', 'Error');
      }
    })
  }


  Reason: any = [
    'Customer Internet',
    'Customer Owned Equipment',
    'Customer Power',
    'Customer Renovations',
    'Customer Request',
    'Customer Success',
    'Collections',
    'Project Management',
    'Relocation',
    'Natural Disaster',
    'Pending Removal',
    'Service Paused',
    'Other'
  ]


  changeReason(e) {
    this.sdtReason = e.value;

    this.modifiedReason;
    switch (e.value) {
      case 'Customer Internet':
        this.modifiedReason = 'customer_internet';
        break;
      case 'Customer Owned Equipment':
        this.modifiedReason = 'customer_owned_equipment';
        break;
      case 'Customer Power':
        this.modifiedReason = 'customer_power';
        break;
      case 'Customer Renovations':
        this.modifiedReason = 'customer_renovations';
        break;
      case 'Customer Request':
        this.modifiedReason = 'customer_request';
        break;
      case 'Customer Success':
        this.modifiedReason = 'customer_success_sdt';
        break;
      case 'Collections':
        this.modifiedReason = 'collections_sdt';
        break;      
      case 'Project Management':
        this.modifiedReason = 'project_management_sdt';
        break;
      case 'Relocation':
        this.modifiedReason = 'relocation_sdt';
        break;
      case 'Natural Disaster':
        this.modifiedReason = 'natural_disaster';
          break;
      case 'Service Paused':
        this.modifiedReason = 'service_paused';
          break;
      case 'Pending Removal':
        this.modifiedReason = 'pending_removal';
          break;
      case 'Other':
        this.modifiedReason = 'other_scheduled_downtime_reason';
          break;  
    }

    this.reasonTag  = this.modifiedReason;

    if (e.value === 'Other') {
      this.sdtForm.controls.otherReason.setValidators([Validators.required]);
      this.sdtForm.controls.otherReason.updateValueAndValidity();
    } else {
      this.sdtForm.controls.otherReason.setValidators([]);
      this.sdtForm.controls.otherReason.updateValueAndValidity();
    }
    this.sdtForm.controls.otherReason.setValue('');
  }


  formatSdt() {
    let date = new Date()
    if (this.sdtForm) {
      const startDate = new Date(this.sdtForm.value.start_date);
      const startMonth = ('0' + (startDate.getMonth() + 1)).slice(-2);
      const startDay = ('0' + startDate.getDate()).slice(-2);
      const startYear = startDate.getFullYear();
      this.startDate = startMonth + '-' + startDay + '-' + startYear;

      const endDate = new Date(this.sdtForm.value.end_date);
      const endMonth = ('0' + (endDate.getMonth() + 1)).slice(-2);
      const endDay = ('0' + endDate.getDate()).slice(-2);
      const endYear = endDate.getFullYear();
      this.endDate = endMonth + '-' + endDay + '-' + endYear;

      this.reason = this.sdtForm.value.reason;
      this.createdBy = this.sdtService.createdBy;
      this.updatedBy = this.sdtService.createdBy;

      const now = new Date();
      const options = { timeZone: 'UTC' as const, year: 'numeric' as const, month: '2-digit' as const, day: '2-digit' as const, hour: '2-digit' as const, minute: '2-digit' as const, second: '2-digit' as const };
      const formatter = new Intl.DateTimeFormat('en-US', options);
      const formattedDate = formatter.format(now).replace(/\//g, '-').slice(0, -3);
      
      this.createdTime = formattedDate
      this.updatedTime = formattedDate
    }
  }

  formatDateToUTC(date) {
    const d = new Date(date);
    const year = d.getUTCFullYear();
    const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    const day = ('0' + d.getUTCDate()).slice(-2);
  
    return `${month}-${day}-${year}`;
  }

  formData() {
    if (this.sdtForm) {
      this.selectedDevicesLength = this.sdtService.selectedDevices.length;
      for (let i = 0; i < this.selectedDevicesLength; i++) {
        this.formatSdt()
        this.sdtService.selectedDevices[i].sdtStartDate = this.formatDateToUTC(this.startDate);
        this.sdtService.selectedDevices[i].sdtEndDate = this.formatDateToUTC(this.endDate);
        this.sdtService.selectedDevices[i].sdtReason = this.reason;
        this.sdtService.selectedDevices[i].createdBy = this.createdBy;
        this.sdtService.selectedDevices[i].updatedBy = this.updatedBy;
        this.sdtService.selectedDevices[i].createdAt = this.createdTime;
        this.sdtService.selectedDevices[i].updatedAt = this.updatedTime;
      }
    }
  }


  private formatData() {
    this.data = this.devices;
    this.dataLength=this.data.length ;
    if (this.data && this.dataLength > 0) {
      this.formattedData = [];
      for (let i = 0; i < this.dataLength; i++) {
        this.formattedData.push({
          "accId": this.data[i]['accId'],
          "siteType": this.data[i]['siteType'],
          "deviceUniqueId": this.data[i]['deviceUniqueId'],
          "deviceType": this.data[i]['deviceType'],
          "type": this.data[i]['type'],
          "deviceName": this.data[i]['deviceName'],
          "siteUnitId": this.data[i]['siteUnitId'],
          "siteName": this.data[i]['siteName'],
          "sdtStartDate": this.startDate,
          "sdtEndDate": this.endDate,
          "sdtReason": this.modifiedReason,
          "sdtStatus": this.data[i]['sdtStatus'],
          "sdtSubReason": (this.reason === 'Other') ? this.sdtForm.value.otherReason : undefined,
          "ticketId": '',
          "createdBy": this.createdBy,
          "updatedBy": this.createdBy,
          "createdAt": this.createdTime,
          "updatedAt": this.createdTime
        });
      }
      return this.formattedData ;
    }
  }

  back(){
    this.router.navigateByUrl('/monitors/');
  }

  onSubmit() {
    this.submitted = true;
    if (this.sdtForm.invalid || this.deviceNames.length == 0) {
      this.validateAllFormFields(this.sdtForm);
    }
    let date = new Date()
    this.sdtForm.touched;
    if (this.sdtForm.value.reason === 'Other') {
      this.sdtForm.controls.otherReason.setValidators([Validators.required]);
      this.sdtForm.controls.otherReason.updateValueAndValidity();
    } else {
      this.sdtForm.controls.otherReason.setValidators([]);
      this.sdtForm.controls.otherReason.updateValueAndValidity();
    }
    if (!this.sdtForm.valid) {
      return false
    }
    else {
      this.formData()
      this.createdBy = this.currentuser.email
      this.sdtService.sdtReason = this.reason
      let sentData = this.formatData();
      let url = AppSettings.SDTPOST
      this.spinner.activate();
      this.restService.postRequest(url, sentData).subscribe((response) => {
        this.postData = response
        if (response && response.success) {
          this.toastr.success((response['messages'] && response['messages'][0]) ? response['messages'][0] : 'SDT Form submitted successfully', '');
          this.openDialog('SDT Form submitted successfully')
          this.router.navigateByUrl('/monitors/');
        } else {
          this.toastr.error((response && response.messages) ? response.messages[0] : '');
          this.openDialog('SDT request was unsuccessful,Please try after some time');
          this.spinner.deactivate();
          this.loading = false;
        }
      },
      );
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
            this.validateAllFormFields(control);
        }
    });
}

  openDialog(msg) {
    const dialogRef = this.dialog.open(DialogAnimationsExampleDialog, {
      width: '390px !important',
      data: { msg: msg }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onDateChange(evt): void {
    this.fromDateMinDate = evt.value;
  }
  onToDateChange(evt): void {
  }
  
  getBrowsername(){
    let browserName = (function (agent) {
      switch (true) {
          case agent.indexOf("edge") > -1: return "MS Edge";
          case agent.indexOf("edg/") > -1: return "Edge ( chromium based)";
          case agent.indexOf("opr") > -1 : return "Opera";
          case agent.indexOf("chrome") > -1 : return "Chrome";
          case agent.indexOf("trident") > -1: return "MS IE";
          case agent.indexOf("firefox") > -1: return "Mozilla Firefox";
          case agent.indexOf("safari") > -1: return "Safari";
          default: return "other";
      }
  })(window.navigator.userAgent.toLowerCase());
      return browserName;
  }
}

@Component({
  selector: 'app-sdt-form',
  templateUrl: 'dialog.html',
  styles: [
    `
  .dialog-title {
    font-size: inherit; 
    font-weight: bold;
    text-align: center;
  }

  .dialog-action {
    display: flex;
    margin-bottom: -10px;
  }

  .dialog-btn {
    margin-right:10px; 
    background-color: #294058;
    color: #fff; 
    text-align: center;
    margin: auto;
  }
  `
  ]
})

export class DialogAnimationsExampleDialog {
  constructor(
    public dialogRef: MatDialogRef<DialogAnimationsExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }
  public close() {
    this.dialogRef.close();
  }
}